const testEmail = (email) => {
  const errorMessages = {
    messages: [
      {text: 'E-mail inválido.', type: 'message-error-icon'},
      {text: 'Por favor, digite um e-mail válido.'}
    ]
  };

  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!re.test(email)) throw errorMessages;
};

export const emailValidator = (email) => {
  try {
    testEmail(email);
    return {status: true, partnerEmail: email};
  } catch (error) {
    return {status: false, partnerEmail: '', error};
  }
};
